import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import PageTitle from "@/components/base/PageTitle";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-zayan-bg flex flex-col">
      <PageTitle title="Page Not Found - Zayan Atelier" />
      <Navbar />
      <div className="flex-1 flex flex-col items-center justify-center text-center px-4 pt-[130px] md:pt-[170px]">
        <span className="font-serif text-8xl md:text-[10rem] text-zayan-gold/10 select-none pointer-events-none">
          404
        </span>
        <div className="relative z-10 -mt-16">
          <h1 className="font-serif text-3xl md:text-4xl text-zayan-gold mb-4">Page Not Found</h1>
          <p className="text-zayan-textMuted text-sm font-mono mb-6">{location.pathname}</p>
          <Link
            to="/"
            className="border border-zayan-gold text-zayan-gold px-8 py-3 text-xs tracking-[0.15em] hover:bg-zayan-gold hover:text-zayan-bg transition-colors whitespace-nowrap"
          >
            RETURN HOME
          </Link>
        </div>
      </div>
    </div>
  );
}